<template>
    <WarningCreateUser v-if="errorCreateUser"/>
    <Title :title="title" />
    <div class="container-form">
        <form class="user-create-form">
            <legend>Ingrese los datos requeridos a continuación para registrar un nuevo usuario</legend>
            <div class="container-right">
                <div class="input-container">
                    <label>Nombre</label>
                    <input v-model="name" type="text" @input="checkForm()"/>
                </div>
                <div class="input-container">
                    <label>Documento de identificación</label>
                    <input v-model="identificationDocument" type="text" @input="checkForm()"/>
                </div>
                <div class="input-container">
                    <label>Rol</label>
                    <select name='rol' id='rol' v-model='idRol' ref="selected" @change="checkForm()">
                        <option
                            value="" disabled>
                            {{defaultValue}}
                        </option>
                        <option
                            v-for="rol in roleList"
                            :key="rol.id"
                            :value="rol.id">
                            {{rol.name}}
                        </option>
                    </select>
                </div>
                <div class="input-container">
                    <label>Contraseña</label>
                    <input v-model="password" type="password"
                    @input="checkForm()"/>
                    <p v-if="!isValidPassword">La contraseña debe tener al menos 8 caracteres, 1 número y 1 caracter especial.</p>
                </div>
            </div>

            <div class="container-left">
                <div class="input-container">
                    <label>Apellido</label>
                    <input v-model="lastName" type="text" @input="checkForm()"/>
                </div>
                <div class="input-container">
                    <label>Institución</label>
                    <input v-model="institution" type="text" @input="checkForm()"/>
                </div>
                <div class="input-container">
                    <label>Correo electronico</label>
                    <input v-model="email" type="text" @input="checkForm()"/>
                </div>
                <div class="input-container">
                    <label>Confirme su contraseña</label>
                    <input v-model="confirmedPassword" type="password"
                    @input="checkForm()"/>
                    <p v-if="!isMatchPassword">Las contraseñas no coinciden</p>
                </div>
            </div>

            <div>
                <button class="button-save"
                    @click.prevent="SaveUser()"
                    :disabled='!seeButton'
                    :class="(seeButton) ? '' : 'button-send'">Guardar</button>
            </div>
        </form>
    </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import Title from '../../../components/ViewsTitle/ViewsTitle.vue'
import { useStore } from 'vuex';
import WarningCreateUser from '../../Warning/WarningCreateUser.vue'
import router from '../../../router';

export default {
    name: 'CreateUserForm',
    components: {
        WarningCreateUser,
        Title
    },
    data (){
        return {
            title: 'CREAR USUARIO',
            defaultValue: 'Seleccione un rol',
            password: '',
            confirmedPassword: '',
            idRol: '',
            name: '',
            lastName: '',
            identificationDocument: '',
            institution: '',
            email: '',
            userAction: 'Create'
        }
    },
    created(){
        const store = useStore();
        store.dispatch('getRole');
    },
    computed: {
        ...mapState(['roleList', 'errorCreateUser', 'seeButton', 'seeToast']),
        isValidPassword() {
            const passwordRegex = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/;
            return passwordRegex.test(this.password);
        },
        isMatchPassword(){
            return this.password === this.confirmedPassword
        },
        isCompleteForm() {
            return this.name && this.lastName && this.identificationDocument && this.institution && this.email && this.idRol !== this.defaultValue
        }
    },
    methods: {
        ...mapActions(['createUser', 'Change_save_create_user']),
        async SaveUser(){
            try {
                await this.createUser({
                name: this.name,
                last_name: this.lastName,
                identification_document: this.identificationDocument,
                institution: this.institution,
                password: this.password,
                email: this.email,
                rol: this.$refs.selected.value,
                })
                if(!this.errorCreateUser){
                    router.push('/')
                    this.$store.commit('change_user_action', this.userAction)
                }
            } catch (error) {
                console.log(error)
            }finally{
                this.password = ""
                this.confirmedPassword = ""
                this.checkForm()
            }
        },
        checkForm(){
            const submissionValidation = {
                isMatchPassword: this.isMatchPassword,
                isPasswordValid: this.isValidPassword,
                isCompleteForm: Boolean(this.isCompleteForm)
            }
            this.Change_save_create_user(submissionValidation);
        }
    }
}
</script>
<style scoped>
.container-form {
    font-family: "Ancizar-regular", Helvetica, Arial;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}
.user-create-form {
    width: 35rem;
    box-sizing: border-box;
    border: 0.15rem solid rgb(100, 120, 20);
    border-radius: .5rem;
    margin-left: 5rem;
}
.input-container {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
}
.container-right, .container-left {
    display: inline-block;
}
.container-left {
    margin-left: .5rem;
}
label{
    font-size: 1.1rem;
    padding: .5rem 0rem 0rem 2rem;
}
input, select {
    margin: .2rem 0rem .5rem 2rem;
    height: 2rem;
    width: 14rem;
    border: 1px solid rgba(55, 55, 55, 0.7);
    border-radius: .5rem;
    padding-left: .5rem ;
}
legend {
    background-color: rgb(100, 120, 20);
    color:white;
    font-size: 1.2rem;
    padding: .3rem .2rem .3rem 2rem;
    line-height: 1.2;
}
.button-save {
    width: 10rem;
    color: white;
    height: 2.5em;
    background-color: rgb(100, 120, 20);
    border-radius: .3rem;
    font-size: 1.1rem;
    margin: 1rem 0rem .8rem 2rem;
}
.button-send{
    width: 8rem;
    color: white;
    height: 2.5em;
    margin: .5rem 0rem .8rem 2rem;
    border: none;
    background-color: rgba(100, 120, 20, 0.658);
}
p {
    margin: .2rem 0rem .5rem 2rem;
    width: 15rem;
    line-height: 1.2;
    color: rgb(84, 104, 5);
    font-weight: bold;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    font-size: .8rem;
}
@media screen and (min-width: 1930px) {
  .user-create-form {
    width: 60rem;
}}
</style>

